import { Icon, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Text = styled.p`
  padding: 8px;
  border-top: 1px solid var(--border-soft);
  padding: 16px 0px;
  margin-top: 16px;
  color: var(--text-soft);
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FallbackWrapper = styled.span`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const FallbackIcon = styled(Icon).attrs({
  iconName: 'GeneralKnowledge',
  size: 20,
  fillColor: '#8e4ec6',
})``;

export const FallbackText = styled.span`
  color: #bf7af0;
  ${typographyV2.bodyXs}
`;
